export const UserIcon = () => {
  return <i className="user-icon pi pi-user" />;
};
